module.exports = "/static/media/lineto-circular-blackItalic.ffd5fae8.woff";